import { useEffect } from "react";
import { RateRepository, RateDiffRepository } from "../repositories/goldRateRepository";
import { useDispatch, useSelector } from "react-redux";
import { GoldRateStateData, setGoldRate } from "../store/goldRateSlice";
import { selectGoldRate } from "../store/sessionSelectors";
import { showError, showSuccess } from "../library/feedback";

export const useGoldRateHook = () => {
    const dispatch = useDispatch();
    const goldRate = useSelector(selectGoldRate);

    useEffect(() => RateRepository.todaysRateOnChange((data) => {
        dispatch(setGoldRate(data.toJson()));
    }), [dispatch]);

    function updateRate(rate: GoldRateStateData) {
        if (rate.gold['24K995'] <= 0 || rate.silver[3] <= 0) {
            showError("Can not have zero rate.");
            return
        }
        RateRepository.AddRate(rate).then(() => {
            showSuccess("Rate updated successfully.");
            dispatch(setGoldRate(rate))
        });
    }

    function updateRateDiff(diff: number) {
        RateDiffRepository.UpdateDiff(diff).then(() => {
            showSuccess("Price difference updated successfully.");
        });
    }

    async function getRateDiff() {
        return await RateDiffRepository.latestRateDiff();
    }



    return {
        goldRate,
        updateRate,
        updateRateDiff,
        getRateDiff,
    }
}